{
  "Terms.print": "Print",
  "ClinicForm.mapsLookup": "Look up on Google maps",
  "Modal.closePrompt": "Are you sure you want to leave?",
  "Modal.closeDescription": "Any information you have entered will not be saved.",
  "Modal.closeButton": "Leave",
  "Modal.closeCancel": "Go back",
  "Footer.back": "Back",
  "Footer.next": "Next",
  "Footer.submit": "Submit",
  "phoneInput.countryOfOrigin": "Phone country of origin",
  "ClinicForm.SelectedClinic": "Selected research centre",
  "Error.CloseModal": "Close",
  "Modal.CloseDialog": "Close dialog",
  "NavigationProgress.SignUp": "See if you pre-qualify",
  "Questionnaire.BMI.Height": "Height",
  "Questionnaire.BMI.Weight": "Weight",
  "Questionnaire.BMI.units.metric": "metric",
  "Questionnaire.BMI.units.imperial": "imperial",
  "Questionnaire.BMI.useStones": "Use stones",
  "Questionnaire.BMI.centimeters": "Centimeters",
  "Questionnaire.BMI.kilograms": "Kilograms",
  "Questionnaire.BMI.feet": "Feet",
  "Questionnaire.BMI.inches": "Inches",
  "Questionnaire.BMI.pounds": "Pounds",
  "Questionnaire.BMI.stone": "Stones",
  "NavigationControls.Questionnaire.select.placeholder": "Select an answer",
  "NavigationControls.NavigationControlsYes": "Yes",
  "NavigationControls.NavigationControlsNo": "No",
  "Questionnaire.QuestionTitle": "Question {number}. {questionText}",
  "Survey.StartButton": "Start",
  "Survey.ContinueButton": "Continue",
  "Intro.caption": "Complete the survey before {date}",
  "RegistrationComplete.ContactUs": "Should you have any questions or concerns, please email us at {email}.",
  "SurveyComplete.ThankYou": "Thank you for taking the time to complete this survey.",
  "SurveyComplete.CompletedTitle": "Survey completed",
  "Terms.back": "Back",
  "Terms.termsOfAgreement": "Terms of Agreement",
  "Terms.recaptchaNotice": "This questionnaire is protected by reCAPTCHA and the Google {privacy} and {terms} apply.",
  "Terms.recaptchaNoticePrivacy": "Privacy Policy",
  "Terms.recaptchaNoticeTerms": "Terms of Service",
  "ClinicForm.SelectClinic": "Select a preferred research centre you would like to visit if you were to take part in the study",
  "ClinicForm.FindNearestClinic": "Find nearest research centre",
  "Footer.FooterNoClinicSelected": "No research centre selected",
  "ContactDetails.prompt": "Please enter your contact details and preferred time of contact so that the study medical team can reach you to discuss study participation.",
  "ContactDetails.PromptNotice": "Submitting your contact details does not mean you have to join the study. That is your decision to make if you are fully eligible for the study.",
  "ContactDetails.privacyDisclaimer": "Your personal information and your answers to the study questions are only used for the purposes of determining if the clinical study is suitable for you. You can at any time withdraw your consent and have your personal data removed.",
  "Elegible.ChooseClinic": "Next",
  "Elegible.SelectPreferedClinic": "In the next step you will select a research centre that you would like to visit during the study if you are eligible and would like to take part.",
  "Elegible.EnterContactDetails": "In the next step you will enter your contact details so that the study medical team can reach you.",
  "Elegible.YouAreElegible": "Based on your responses, you may be suitable for the study.",
  "Error.PleaseTryAgain": "Please try again later",
  "Error.NoToken": "Please contact support {email}",
  "Error.NoTokenTitle": "Token is missing or invalid",
  "Error.SessionTimedOut": "The signup process has ended due to inactivity. Please restart the sign-up process.",
  "Error.SessionTimedOutTitle": "Your session has expired",
  "SurveyComplete.AlreadyCompleted": "This survey was already completed on {completedAt}",
  "SurveyComplete.AlreadyCompletedTitle": "Already completed",
  "SurveyInactive.Status": "This survey is {status}",
  "SurveyInactive.NotStartedTitle": "Survey not started",
  "SurveyInactive.NotStarted": "This survey will start on {date}",
  "SurveyInactive.EndedTitle": "Survey closed",
  "SurveyInactive.Ended": "This survey ended on {date}",
  "Error.NoResponse": "No response from server",
  "Error.UnknownError": "An unknown error occurred",
  "ContactDetails.name": "Name",
  "ContactDetails.namePlaceholder": "Your name",
  "ContactDetails.email": "Email address",
  "ContactDetails.emailPlaceholder": "Your email address",
  "ContactDetails.emailConfirm": "Confirm email address",
  "ContactDetails.emailConfirmPlaceholder": "Confirm email address",
  "ContactDetails.phone": "Phone number",
  "ContactDetails.phonePlaceholder": "Your phone number",
  "ContactDetails.phoneConfirm": "Confirm phone number",
  "ContactDetails.phoneConfirmPlaceholder": "Confirm phone number",
  "FormSelect.preferred_contact_way": "Preferred way to be contacted",
  "ContactDetails.preferred_contact_wayPlaceholder": "Choose preferred method",
  "FormSelect.availability_slots": "Preferred time to be contacted",
  "ContactDetails.availability_slotsPlaceholder": "Choose time",
  "Error.MinimumCharacters": "Please enter your whole name",
  "Error.MaximumCharacters": "Please enter a shorter version of your name",
  "Error.NotValidEmail": "Please enter a valid email",
  "Error.NonEqualEmail": "The email addresses do not match",
  "Error.PleaseSelectAvailabilitySlot": "Please select a timeslot for preferred contact",
  "Error.PleaseSelectContactWay": "Please select a preferred way to be contacted",
  "Error.NotValidPhoneNumber": "Please enter a valid phone number",
  "Error.NotEqualPhoneNumber": "The phone numbers do not match",
  "Error.YouMustConsent": "You cannot proceed without consenting. If you do not wish to consent, you can close the window in the upper right corner.",
  "ContactTimes.8-20": "Anytime",
  "ContactTimes.8-12": "8:00 am - 12:00 noon",
  "ContactTimes.12-16": "12:00 noon - 4:00 pm",
  "ContactTimes.16-20": "4:00 pm - 8:00 pm",
  "Modal.NavProgressStudyQuestions": "Questions",
  "Modal.LocationPreference": "Location",
  "Modal.NavProgressContactDetails": "Contact",
  "NotEligible.CloseButton": "Close",
  "NotEligible.NotEligible": "Sorry, the study is not suitable for you at this time",
  "Questionnaire.Progress": "{questionsAnswered} of {totalQuestions} answered",
  "Warning.SkippedQuestions": "{count} questions skipped",
  "Questionnaire.Prompt": "Please answer the following questions to find out if you are suitable for the study.",
  "RegistrationComplete.Done": "Done",
  "Registration.RegistrationNowFinished": "Thank you for your interest. An email has been sent to {email}. You will be contacted by the study medical team shortly to talk about the study.",
  "Registration.RegistrationComplete": "Registration completed!",
  "Welcome.Participate": "I want to participate",
  "Welcome.FindOutIfQualify": "Find out if this study is a match for you",
  "Welcome.ToSignUp": "Please answer a few questions to see if you may qualify for the study.",
  "Countries.AF": "Afghanistan",
  "Countries.AX": "Åland Islands",
  "Countries.AL": "Albania",
  "Countries.DZ": "Algeria",
  "Countries.AS": "American Samoa",
  "Countries.AD": "Andorra",
  "Countries.AO": "Angola",
  "Countries.AI": "Anguilla",
  "Countries.AQ": "Antarctica",
  "Countries.AG": "Antigua and Barbuda",
  "Countries.AR": "Argentina",
  "Countries.AM": "Armenia",
  "Countries.AW": "Aruba",
  "Countries.AU": "Australia",
  "Countries.AT": "Austria",
  "Countries.AZ": "Azerbaijan",
  "Countries.BS": "Bahamas",
  "Countries.BH": "Bahrain",
  "Countries.BD": "Bangladesh",
  "Countries.BB": "Barbados",
  "Countries.BY": "Belarus",
  "Countries.BE": "Belgium",
  "Countries.BZ": "Belize",
  "Countries.BJ": "Benin",
  "Countries.BM": "Bermuda",
  "Countries.BT": "Bhutan",
  "Countries.BO": "Bolivia (Plurinational State of)",
  "Countries.BQ": "Bonaire, Sint Eustatius and Saba",
  "Countries.BA": "Bosnia and Herzegovina",
  "Countries.BW": "Botswana",
  "Countries.BV": "Bouvet Island",
  "Countries.BR": "Brazil",
  "Countries.IO": "British Indian Ocean Territory",
  "Countries.UM": "United States Minor Outlying Islands",
  "Countries.VG": "Virgin Islands (British)",
  "Countries.VI": "Virgin Islands (U.S.)",
  "Countries.BN": "Brunei Darussalam",
  "Countries.BG": "Bulgaria",
  "Countries.BF": "Burkina Faso",
  "Countries.BI": "Burundi",
  "Countries.KH": "Cambodia",
  "Countries.CM": "Cameroon",
  "Countries.CA": "Canada",
  "Countries.CV": "Cabo Verde",
  "Countries.KY": "Cayman Islands",
  "Countries.CF": "Central African Republic",
  "Countries.TD": "Chad",
  "Countries.CL": "Chile",
  "Countries.CN": "China",
  "Countries.CX": "Christmas Island",
  "Countries.CC": "Cocos (Keeling) Islands",
  "Countries.CO": "Colombia",
  "Countries.KM": "Comoros",
  "Countries.CG": "Congo",
  "Countries.CD": "Congo (Democratic Republic of the)",
  "Countries.CK": "Cook Islands",
  "Countries.CR": "Costa Rica",
  "Countries.HR": "Croatia",
  "Countries.CU": "Cuba",
  "Countries.CW": "Curaçao",
  "Countries.CY": "Cyprus",
  "Countries.CZ": "Czech Republic",
  "Countries.DK": "Denmark",
  "Countries.DJ": "Djibouti",
  "Countries.DM": "Dominica",
  "Countries.DO": "Dominican Republic",
  "Countries.EC": "Ecuador",
  "Countries.EG": "Egypt",
  "Countries.SV": "El Salvador",
  "Countries.GQ": "Equatorial Guinea",
  "Countries.ER": "Eritrea",
  "Countries.EE": "Estonia",
  "Countries.ET": "Ethiopia",
  "Countries.FK": "Falkland Islands (Malvinas)",
  "Countries.FO": "Faroe Islands",
  "Countries.FJ": "Fiji",
  "Countries.FI": "Finland",
  "Countries.FR": "France",
  "Countries.GF": "French Guiana",
  "Countries.PF": "French Polynesia",
  "Countries.TF": "French Southern Territories",
  "Countries.GA": "Gabon",
  "Countries.GM": "Gambia",
  "Countries.GE": "Georgia",
  "Countries.DE": "Germany",
  "Countries.GH": "Ghana",
  "Countries.GI": "Gibraltar",
  "Countries.GR": "Greece",
  "Countries.GL": "Greenland",
  "Countries.GD": "Grenada",
  "Countries.GP": "Guadeloupe",
  "Countries.GU": "Guam",
  "Countries.GT": "Guatemala",
  "Countries.GG": "Guernsey",
  "Countries.GN": "Guinea",
  "Countries.GW": "Guinea-Bissau",
  "Countries.GY": "Guyana",
  "Countries.HT": "Haiti",
  "Countries.HM": "Heard Island and McDonald Islands",
  "Countries.VA": "Holy See",
  "Countries.HN": "Honduras",
  "Countries.HK": "Hong Kong",
  "Countries.HU": "Hungary",
  "Countries.IS": "Iceland",
  "Countries.IN": "India",
  "Countries.ID": "Indonesia",
  "Countries.CI": "Côte d'Ivoire",
  "Countries.IR": "Iran (Islamic Republic of)",
  "Countries.IQ": "Iraq",
  "Countries.IE": "Ireland",
  "Countries.IM": "Isle of Man",
  "Countries.IL": "Israel",
  "Countries.IT": "Italy",
  "Countries.JM": "Jamaica",
  "Countries.JP": "Japan",
  "Countries.JE": "Jersey",
  "Countries.JO": "Jordan",
  "Countries.KZ": "Kazakhstan",
  "Countries.KE": "Kenya",
  "Countries.KI": "Kiribati",
  "Countries.KW": "Kuwait",
  "Countries.KG": "Kyrgyzstan",
  "Countries.LA": "Lao People's Democratic Republic",
  "Countries.LV": "Latvia",
  "Countries.LB": "Lebanon",
  "Countries.LS": "Lesotho",
  "Countries.LR": "Liberia",
  "Countries.LY": "Libya",
  "Countries.LI": "Liechtenstein",
  "Countries.LT": "Lithuania",
  "Countries.LU": "Luxembourg",
  "Countries.MO": "Macao",
  "Countries.MK": "Macedonia (the former Yugoslav Republic of)",
  "Countries.MG": "Madagascar",
  "Countries.MW": "Malawi",
  "Countries.MY": "Malaysia",
  "Countries.MV": "Maldives",
  "Countries.ML": "Mali",
  "Countries.MT": "Malta",
  "Countries.MH": "Marshall Islands",
  "Countries.MQ": "Martinique",
  "Countries.MR": "Mauritania",
  "Countries.MU": "Mauritius",
  "Countries.YT": "Mayotte",
  "Countries.MX": "Mexico",
  "Countries.FM": "Micronesia (Federated States of)",
  "Countries.MD": "Moldova (Republic of)",
  "Countries.MC": "Monaco",
  "Countries.MN": "Mongolia",
  "Countries.ME": "Montenegro",
  "Countries.MS": "Montserrat",
  "Countries.MA": "Morocco",
  "Countries.MZ": "Mozambique",
  "Countries.MM": "Myanmar",
  "Countries.NA": "Namibia",
  "Countries.NR": "Nauru",
  "Countries.NP": "Nepal",
  "Countries.NL": "Netherlands",
  "Countries.NC": "New Caledonia",
  "Countries.NZ": "New Zealand",
  "Countries.NI": "Nicaragua",
  "Countries.NE": "Niger",
  "Countries.NG": "Nigeria",
  "Countries.NU": "Niue",
  "Countries.NF": "Norfolk Island",
  "Countries.KP": "Korea (Democratic People's Republic of)",
  "Countries.MP": "Northern Mariana Islands",
  "Countries.NO": "Norway",
  "Countries.OM": "Oman",
  "Countries.PK": "Pakistan",
  "Countries.PW": "Palau",
  "Countries.PS": "Palestine, State of",
  "Countries.PA": "Panama",
  "Countries.PG": "Papua New Guinea",
  "Countries.PY": "Paraguay",
  "Countries.PE": "Peru",
  "Countries.PH": "Philippines",
  "Countries.PN": "Pitcairn",
  "Countries.PL": "Poland",
  "Countries.PT": "Portugal",
  "Countries.PR": "Puerto Rico",
  "Countries.QA": "Qatar",
  "Countries.XK": "Republic of Kosovo",
  "Countries.RE": "Réunion",
  "Countries.RO": "Romania",
  "Countries.RU": "Russian Federation",
  "Countries.RW": "Rwanda",
  "Countries.BL": "Saint Barthélemy",
  "Countries.SH": "Saint Helena, Ascension and Tristan da Cunha",
  "Countries.KN": "Saint Kitts and Nevis",
  "Countries.LC": "Saint Lucia",
  "Countries.MF": "Saint Martin (French part)",
  "Countries.PM": "Saint Pierre and Miquelon",
  "Countries.VC": "Saint Vincent and the Grenadines",
  "Countries.WS": "Samoa",
  "Countries.SM": "San Marino",
  "Countries.ST": "Sao Tome and Principe",
  "Countries.SA": "Saudi Arabia",
  "Countries.SN": "Senegal",
  "Countries.RS": "Serbia",
  "Countries.SC": "Seychelles",
  "Countries.SL": "Sierra Leone",
  "Countries.SG": "Singapore",
  "Countries.SX": "Sint Maarten (Dutch part)",
  "Countries.SK": "Slovakia",
  "Countries.SI": "Slovenia",
  "Countries.SB": "Solomon Islands",
  "Countries.SO": "Somalia",
  "Countries.ZA": "South Africa",
  "Countries.GS": "South Georgia and the South Sandwich Islands",
  "Countries.KR": "Korea (Republic of)",
  "Countries.SS": "South Sudan",
  "Countries.ES": "Spain",
  "Countries.LK": "Sri Lanka",
  "Countries.SD": "Sudan",
  "Countries.SR": "Suriname",
  "Countries.SJ": "Svalbard and Jan Mayen",
  "Countries.SZ": "Swaziland",
  "Countries.SE": "Sweden",
  "Countries.CH": "Switzerland",
  "Countries.SY": "Syrian Arab Republic",
  "Countries.TW": "Taiwan",
  "Countries.TJ": "Tajikistan",
  "Countries.TZ": "Tanzania, United Republic of",
  "Countries.TH": "Thailand",
  "Countries.TL": "Timor-Leste",
  "Countries.TG": "Togo",
  "Countries.TK": "Tokelau",
  "Countries.TO": "Tonga",
  "Countries.TT": "Trinidad and Tobago",
  "Countries.TN": "Tunisia",
  "Countries.TR": "Turkey",
  "Countries.TM": "Turkmenistan",
  "Countries.TC": "Turks and Caicos Islands",
  "Countries.TV": "Tuvalu",
  "Countries.UG": "Uganda",
  "Countries.UA": "Ukraine",
  "Countries.AE": "United Arab Emirates",
  "Countries.GB": "United Kingdom of Great Britain and Northern Ireland",
  "Countries.US": "United States of America",
  "Countries.UY": "Uruguay",
  "Countries.UZ": "Uzbekistan",
  "Countries.VU": "Vanuatu",
  "Countries.VE": "Venezuela (Bolivarian Republic of)",
  "Countries.VN": "Viet Nam",
  "Countries.WF": "Wallis and Futuna",
  "Countries.EH": "Western Sahara",
  "Countries.YE": "Yemen",
  "Countries.ZM": "Zambia",
  "Countries.ZW": "Zimbabwe",
  "ContactDetails.phone_option_placeholder": "Phone call",
  "ContactDetails.sms_option_placeholder": "SMS",
  "ContactDetails.email_option_placeholder": "Email",
  "Consent.SeeFullVersionLink": "Full version",
  "ContactDetails.PostalCode": "Postal code",
  "ContactDetails.PostalCodePlaceholder": "Your postal code",
  "Error.NotValidPostalCode": "Please enter a valid postal code"
}
